import React, { useImperativeHandle } from 'react';
import { Content, DecoratorBox, Description, Label, SelectItemContainer } from "./SelectItem.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple SelectItem component.
 *
 * @param id Id of the item
 * @param label Label of the item
 * @param description Description of the item
 * @param leftDecorator Left decorator of the item
 * @param rightDecorator Right decorator of the item
 * @param hightlighted If the item is hightlighted
 * @param selected If the item is selected
 * @param onClick Click event
 *
 */

const SelectItem = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    label,
    description,
    leftDecorator,
    rightDecorator,
    selected,
    size = 'md',
    hightlighted,
    onClick
  } = props;
  const targetRef = {
    disabled: false,
    value,
    selected: selected ?? false,
    label,
    text: label
  };
  useImperativeHandle(ref, () => targetRef);
  return /*#__PURE__*/_jsxs(SelectItemContainer, {
    onClick: () => {
      onClick?.({
        target: targetRef
      });
    },
    size: size,
    selected: selected,
    highlighted: hightlighted,
    children: [leftDecorator && /*#__PURE__*/_jsx(DecoratorBox, {
      children: leftDecorator
    }), /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Label, {
        children: label
      }), /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    }), rightDecorator && /*#__PURE__*/_jsx(DecoratorBox, {
      children: rightDecorator
    })]
  });
});
SelectItem.displayName = 'SelectItem';
export { SelectItem };